import React, { useEffect } from 'react';
import { useAPIWrapper, DetailBySchema, FormFieldLayout } from 'drf-react-by-schema';
import { useNavigate } from 'react-router-dom';

import EditIcon from '@mui/icons-material/Edit';

import Box from '@mui/material/Box';

import { useAppSelector } from 'src/app/hooks';
import { setPage } from 'src/features/pageSlice';
import { appDispatch } from 'src/utils/utils';

import AsmubipButton from 'src/components/AsmubipButton';
import { useHasPermissionsMulti } from 'src/hooks/useHasPermissions';
import { GENERAL_ADMINS } from 'src/constants/Permission';
import { detailNonAccordion } from 'src/styles/layout';

const MODEL = 'entreposto';

const FIELDS_LAYOUT: FormFieldLayout[] = [
  {
    title: 'Identificação',
    rows: ['nome', 'municipio'],
    ...detailNonAccordion,
  },
  {
    title: 'Grupos de origem dos flocos',
    rows: ['grupos_fornecedores'],
    ...detailNonAccordion,
  },
  {
    title: 'Logomarca ou imagem',
    rows: ['logomarca'],
    ...detailNonAccordion,
  },
];

export default function EntrepostoDetail() {
  const { formValues, perfil, key, id, isMobile } = useAppSelector((state) => state.page);
  const { pageForm, loadSinglePageData } = useAPIWrapper();
  const navigate = useNavigate();
  const [isAdmin] = useHasPermissionsMulti([GENERAL_ADMINS]);

  const handleEditClick = () => {
    if (!id) {
      return;
    }
    navigate(`/${key}/edit/${id}`);
  };

  useEffect(() => {
    const loadAllDataAsync = async () => {
      // Ok: id was not loaded yet in authrouter:
      if (id === null || !perfil) {
        return;
      }

      // Not ok if not admin: id was loaded and is undefined: non admins go to view page!
      if (!isAdmin && !id) {
        navigate(
          key === 'entreposto' && perfil.entreposto
            ? `/entreposto/view/${perfil.entreposto.id}`
            : '/'
        );
        return;
      }

      const values = await loadSinglePageData({
        model: MODEL,
        objId: id,
      });
      if (values) {
        const pageTitle = values.nome;
        appDispatch(
          setPage({
            id: id,
            model: MODEL,
            formValues: values,
            title: pageTitle,
          })
        );
      }
    };
    loadAllDataAsync();
  }, [id, key, perfil, isAdmin]);

  if (!pageForm?.schema || !pageForm.columns || !formValues || !perfil) {
    return null;
  }

  return (
    <>
      <DetailBySchema
        schema={pageForm.schema}
        columns={pageForm.columns}
        values={formValues}
        fieldsLayout={FIELDS_LAYOUT}
        elevation={0}
      />
      <Box
        sx={
          isMobile
            ? { paddingBottom: 2 }
            : { display: 'flex', justifyContent: 'flex-end', paddingBottom: 2, marginTop: 2 }
        }>
        <AsmubipButton
          variant="contained-secondary"
          fullWidth={isMobile}
          aria-label="editar"
          size="large"
          onClick={handleEditClick}
          startIcon={<EditIcon />}>
          Editar
        </AsmubipButton>
      </Box>
    </>
  );
}
